///home/cockskiz/new.greatlysocial.com/frontend/src/components/GlobalLoading.js
import React from 'react'

export default function GlobalLoading({ show = false, text = '' }) {
  if (!show) return null
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(255,255,255,0.8)',
      zIndex: 99999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div className="spinner-border text-primary" style={{ width: 60, height: 60 }} />
      {text && <div style={{ marginTop: 18, color: '#333', fontWeight: 500 }}>{text}</div>}
    </div>
  )
}
